import { useEffect, useState } from 'react'
import { chatService } from 'services/ChatService'
import { AsyncHookResponse, OpenAIModel } from 'types/'

const useChatModels = (value: string): AsyncHookResponse<OpenAIModel[]> => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const [result, setResult] = useState<OpenAIModel[]>()

  const fetchAIResponse = (value: string) => {
    setLoading(true)
    setError(false)

    chatService
      .getModelsResponse(value)
      .then((promptResponse) => {
        setResult(promptResponse)
        setLoading(false)
      })
      .catch((e) => {
        console.error('Error:', e)
        setError(true)
        setLoading(false)
      })
  }

  useEffect(() => {
    fetchAIResponse(value)
  }, [])

  return { result, loading, error }
}

export default useChatModels
